<template>
  <BreadCrumb PageTitle="Liste des colis (Stock)" />
  <ImportColisStock />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ImportColisStock from "../../components/Colis/ImportColisStock.vue";

export default defineComponent({
  name: "ImportColisStockPage",
  components: {
    BreadCrumb,
    ImportColisStock,
  },
});
</script>